<!-- @format -->

@if (sameDayDeliveryButtonText$ | async; as sameDayDeliveryButtonText) {
	<div id="pdp-same-day-delivery-button">
		<pdp-add-to-cart-component-fulfillment-button
			#fulfillmentButton
			(buttonClicked)="setShipMode()"
			[isSelected]="(shipMode$ | async) === 'sameDayDelivery'"
			[isDisabled]="
				sameDayDeliveryButtonText.fulfillmentButtonDisabledClass &&
				!isZipcodeNotSetAndSkuResolved
			">
			<homefield-icon
				class="fulfillment-icon dynamic-fill"
				width="36px"
				height="36px"
				[name]="fulfillmentIconName">
			</homefield-icon>
			<span fulfillment-type-label>Same Day Delivery</span>
			<span
				fulfillmentText
				class="">
				{{ fulfillmentButtonTextSDDynamic }}
				@if (sameDayDeliveryButtonText.showZipCodeButton) {
					<pdp-feature-change-zip-code-button
						[isSubtle]="true"></pdp-feature-change-zip-code-button>
				}
			</span>
		</pdp-add-to-cart-component-fulfillment-button>
	</div>
}
